import React from 'react';
import '../../css/vers2/AboutSection.css';

type AboutSectionProps = {
    setPage: React.Dispatch<React.SetStateAction<string>>;
};

const AboutSection = ({ setPage }: AboutSectionProps) => {
    return (
        <section id="over-mij" className="about-new-section blue-bg">
            <div className="about-red-dot" />
            <div className="about-cream-dot" />

            <div className="about-yellow-drop">
                <svg viewBox="0 0 90 140">
                    <path d="M14 2C25 42 72 49 79 91C86 129 45 151 18 122C-5 96 3 45 14 2Z" />
                </svg>
            </div>

            <div className="about-green-drop">
                <svg viewBox="0 0 120 80">
                    <path d="M4 76C16 28 42 4 80 10C115 15 128 48 98 64C75 77 35 61 4 76Z" />
                </svg>
            </div>

            <img className="about-kite" src="/icons/about_me/vlieger.png" alt="" />

            <h2 className="about-title">
                <span className="title-line line-1">Jestica</span>
                <span className="title-line line-2">Cijntje</span>
            </h2>

            <div className="about-photo">
                <svg viewBox="0 0 400 400" className="photo-mask">
                    <defs>
                        <clipPath id="photoSquiggleClip">
                            <path d="M200 28 C218 28 226 48 244 52 C263 56 280 42 296 53 C312 65 306 88 320 100 C334 113 357 109 365 128 C373 147 354 163 358 182
                                    C362 201 384 212 378 232 C372 252 348 254 340 272 C332 291 345 312 329 326 C314 340 292 328 275 338 C258 348 254 372 234 376
                                    C215 380 204 358 185 358 C166 358 153 379 134 373 C116 368 115 344 99 333 C83 322 60 331 48 315 C36 299 51 279 44 260 C38 241 15 235 18 215
                                    C21 195 44 186 45 166 C46 147 27 132 37 114 C47 96 70 101 84 87 C98 73 93 50 112 42 C130 34 146 51 164 47 C182 43 182 28 200 28 Z" />
                        </clipPath>
                    </defs>

                    <image
                        href="/images/pica.jpg"
                        width="400"
                        height="400"
                        clipPath="url(#photoSquiggleClip)"
                        preserveAspectRatio="xMidYMid slice"
                    />

                    <path
                        d="M200 28 C218 28 226 48 244 52 C263 56 280 42 296 53 C312 65 306 88 320 100 C334 113 357 109 365 128 C373 147 354 163 358 182 C362 201 384 212 378 232 C372 252 348 254 340 272 C332 291 345 312 329 326
                            C314 340 292 328 275 338 C258 348 254 372 234 376 C215 380 204 358 185 358 C166 358 153 379 134 373 C116 368 115 344 99 333 C83 322 60 331 48 315 C36 299 51 279 44 260
                            C38 241 15 235 18 215 C21 195 44 186 45 166 C46 147 27 132 37 114 C47 96 70 101 84 87 C98 73 93 50 112 42 C130 34 146 51 164 47 C182 43 182 28 200 28 Z"
                        fill="none"
                        stroke="#e56f8d"
                        strokeWidth="10"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                </svg>
            </div>

            <div className="about-contact-list">
                <div className="contact-row">
                    <img src="/icons/about_me/phoneIcon.png" alt="" />
                    <span>06 45497001</span>
                </div>
                <div className="contact-row">
                    <img src="/icons/about_me/adresIcon.png" alt="" />
                    <span>Maaskanterf 166,<br />3315KN Dordrecht</span>
                </div>
                <div className="contact-row">
                    <img src="/icons/about_me/emailIcon.png" alt="" />
                    <span>jestica.cijntje@hotmail.com</span>
                </div>
            </div>

            <div className="about-text">
                <p>
                    Ik zal mijzelf even voorstellen, mijn naam is Jestica Cijntje en ik ben
                    55 jaar oud. Ik heb 3 kinderen: twee dochters en 1 zoon. Ook heb ik 6
                    prachtige kleinkinderen.
                </p>
                <p>
                    Omdat ik uit een groot gezin kom, deed ik al vroeg oppassen op mijn
                    nichtjes en neefjes. Voor deze reden ben ik Pedagogisch medewerker gaan
                    studeren, zodat ik met kinderen kon blijven werken.
                </p>
            </div>
        </section>
    );
};

export default AboutSection;
